import { useState } from 'react';

import { Button } from 'primereact/button';

import type { ScheduledSemenResponse } from '@/services/semen-pull/types';

import { CreateSemenDialog } from '../dialogs/CreateSemenDialog';
import { useSemenPullContext } from '../useSemenPullContext';

type Props = {
  data: ScheduledSemenResponse;
};

export const CreateSemenButton = ({ data }: Props) => {
  const { setCurrentScheduledSemen } = useSemenPullContext();
  const [createSemenDialogVisible, setCreateSemenDialogVisible] =
    useState(false);
  return (
    <div>
      <Button
        icon="pi pi-plus"
        size="small"
        text
        rounded
        onClick={() => {
          setCreateSemenDialogVisible(true);
          setCurrentScheduledSemen(() => data);
        }}
      ></Button>
      {createSemenDialogVisible && (
        <CreateSemenDialog
          createSemenDialogVisible={createSemenDialogVisible}
          setCreateSemenDialogVisible={setCreateSemenDialogVisible}
        ></CreateSemenDialog>
      )}
    </div>
  );
};
